import React from 'react';
import cn from 'classnames';

import RailSkeleton from 'components/widgets/Rail/components/RailSkeleton/RailSkeleton';

import styles from './Skeleton.module.scss';

type SkeletonProps = {
  itemWidth: number;
  itemHeigh: number;
  numberOfElements: number;
  className?: string;
};
export function Skeleton({ itemWidth, itemHeigh, numberOfElements, className }: SkeletonProps) {
  return (
    <div className={cn(styles.railSkeleton, className)}>
      <header className={styles.titleSkeleton} />
      <header className={styles.descriptionSkeleton} />
      <div>
        {new Array(numberOfElements).fill(0).map((index) => {
          return <RailSkeleton
            numberOfCells={1}
            key={`${Math.random() + index}`}
            settings={
              ({
                imageWidth: itemWidth,
                imageHeight: itemHeigh,
              })
            }

          />;
        })}
      </div>
    </div>
  );
}
